import { render } from "./PRegionalGroups.vue?vue&type=template&id=e1200d30&scoped=true"
import script from "./PRegionalGroups.vue?vue&type=script&lang=js"
export * from "./PRegionalGroups.vue?vue&type=script&lang=js"

import "./PRegionalGroups.vue?vue&type=style&index=0&id=e1200d30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1200d30"]])

export default __exports__